import { isInsideIFrame } from '../utils/iframe';
import { EventManager } from './EventManager';
export var IFrameMessageType;
(function (IFrameMessageType) {
  IFrameMessageType["ElementClicked"] = "kontent-smart-link:element:clicked";
  IFrameMessageType["Initialized"] = "kontent-smart-link:initialized";
  IFrameMessageType["Status"] = "kontent-smart-link:status";
})(IFrameMessageType || (IFrameMessageType = {}));
var IFrameCommunicator = /** @class */function () {
  function IFrameCommunicator() {
    var _this = this;
    this.addMessageListener = function (type, listener) {
      _this.events.on(type, listener);
    };
    this.removeMessageListener = function (type, listener) {
      _this.events.off(type, listener);
    };
    this.sendMessage = function (type, data) {
      if (!isInsideIFrame()) {
        console.error("Warning: can't send an iframe message, because the application is not hosted in an iframe");
        return;
      }
      var message = {
        type: type,
        data: data
      };
      window.parent.postMessage(message, '*');
    };
    this.onMessage = function (event) {
      if (!event.data) return;
      var message = event.data;
      _this.events.emit(message.type, message.data);
    };
    this.events = new EventManager();
    window.addEventListener('message', this.onMessage, true);
  }
  IFrameCommunicator.prototype.destroy = function () {
    this.events.removeAllListeners();
    window.removeEventListener('message', this.onMessage, true);
  };
  return IFrameCommunicator;
}();
export { IFrameCommunicator };